import { render, staticRenderFns } from "./CashDocumentDetails.vue?vue&type=template&id=0b94dd9e&scoped=true&"
import script from "./CashDocumentDetails.vue?vue&type=script&lang=ts&"
export * from "./CashDocumentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CashDocumentDetails.vue?vue&type=style&index=0&id=0b94dd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94dd9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VDivider,VRow})
